export default __webpack_public_path__ + "device_floodlight_cam_wired_pro.3a680178.png";